


















import Vue from 'vue';
import Component from 'vue-class-component';
import * as Logger from 'js-logger';
import { Prop } from 'vue-property-decorator'
import { IPickUser } from '@/models/pick-user';

const log = Logger.get('UserPicker');

@Component
export default class UserPicker extends Vue {
  @Prop({ required: true })
  users!: IPickUser[];

  userClicked(user: IPickUser) {
    this.$emit('user-picked', user);
  }
}
